// import Account from "@/helper/AccountHelper.js";
import ConfigManager from "@/config/ConfigManager.js";
import BzbsApi from '@/core/Http/BzbsApi.js';
import { map } from 'rxjs/operators';

/**
 * @method requestOtp
 * @method confirmOtp
 * @method validateOtp
 */
export default {
    requestOtp: function(contactNumber) {
        const params = {
            contact_number: contactNumber,
        };
        const url = ConfigManager.getApiModuleUrl() + "/auth/forget_password";
        return BzbsApi.connectBzbsGet(url, null, params).pipe(map(res => res.data));
    },
    validateOtp: function (contactNumber, refcode, otp) {
        const params = {
            contact_number: contactNumber,
            otp: otp,
            refcode: refcode,
        };
        const url = ConfigManager.getApiModuleUrl() + "/auth/forget_password_validate";
        return BzbsApi.connectBzbsPost(url, null, params).pipe(map(res => res.data));
    },
    changePassword: function (data) {
        const params = {
            contact_number: data.contactNumber,
            refcode: data.refcode,
            otp: data.otp,
            password: data.password,
            confirmpassword: data.confirmpassword,
            password_type: data.password_type,
        };

        const url = ConfigManager.getApiModuleUrl() + "/auth/forget_password_change";
        return BzbsApi.connectBzbsPost(url, null, params).pipe(map(res => res.data));
    },
}
